export const Location = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Frame">
        <path
          id="Vector"
          d="M11.7714 11.1047L8.94275 13.9333C8.81905 14.0571 8.67215 14.1554 8.51046 14.2224C8.34877 14.2894 8.17545 14.3239 8.00042 14.3239C7.82539 14.3239 7.65207 14.2894 7.49038 14.2224C7.32869 14.1554 7.18179 14.0571 7.05808 13.9333L4.22875 11.1047C3.4829 10.3588 2.97497 9.40845 2.76921 8.3739C2.56344 7.33934 2.66908 6.267 3.07275 5.29247C3.47643 4.31795 4.16002 3.48501 5.03707 2.89899C5.91413 2.31297 6.94526 2.00018 8.00008 2.00018C9.05491 2.00018 10.086 2.31297 10.9631 2.89899C11.8402 3.48501 12.5237 4.31795 12.9274 5.29247C13.3311 6.267 13.4367 7.33934 13.231 8.3739C13.0252 9.40845 12.5173 10.3588 11.7714 11.1047Z"
          stroke="#2B3033"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M10 7.33331C10 7.86375 9.78929 8.37245 9.41421 8.74753C9.03914 9.1226 8.53043 9.33331 8 9.33331C7.46957 9.33331 6.96086 9.1226 6.58579 8.74753C6.21071 8.37245 6 7.86375 6 7.33331C6 6.80288 6.21071 6.29417 6.58579 5.9191C6.96086 5.54403 7.46957 5.33331 8 5.33331C8.53043 5.33331 9.03914 5.54403 9.41421 5.9191C9.78929 6.29417 10 6.80288 10 7.33331Z"
          stroke="#2B3033"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
